import React from "react"
import { connect } from "react-redux";
import { fetchActiveList, fetchActiveListRange, fetchMonthlyList } from "../store/actions/dashboards";
import Stat from "../components/dashboards/Stat";
import withAuth from "../hocs/withAuth"

class MainStats extends React.Component {
  render() {
    return <Stat
        {...this.props}
      ></Stat>    
  }
}

function mapStateToProps(state, ownProps) {
  return {
    dashboard: state.dashboard,
    brand: state.brand.detail
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchActiveList: (param) => {
      return dispatch(fetchActiveList(param));
    },
    fetchActiveListRange: (query) => {
      return dispatch(fetchActiveListRange(query));
    },
    fetchMonthlyList: (query) => {
      return dispatch(fetchMonthlyList(query));
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(MainStats));



// WEBPACK FOOTER //
// ./src/containers/Stats.js